const EU_COUNTRIES = [
  'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR',
  'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL',
  'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE',
  'IS', 'LI', 'NO', // EEA
];

const GDPR_COUNTRIES = [...EU_COUNTRIES, 'GB'];

export type ConsentRegion = 'gdpr' | 'other';

export async function detectConsentRegion(): Promise<ConsentRegion> {
  try {
    const baseUrl =
      process.env.REACT_APP_API_URL_AXIOS ||
      (window as Window & { env?: { REACT_APP_API_URL_AXIOS?: string } }).env
        ?.REACT_APP_API_URL_AXIOS ||
      '';
    const response = await fetch(`${baseUrl}/geo`);
    const data = await response.json();
    const country = data?.country?.toUpperCase() || 'XX';
    if (country === 'XX') return 'gdpr'; // unknown region, default to GDPR
    return GDPR_COUNTRIES.includes(country) ? 'gdpr' : 'other';
  } catch {
    // Default to GDPR to be safe
    return 'gdpr';
  }
}
